/** Chromium / Brave-specific browser signals. */
export async function collectChromiumSpecific() {
  if (typeof navigator.brave === 'undefined' || typeof navigator.brave.isBrave !== 'function') {
    return {};
  }
  return {
    brave: {
      isBrave: await navigator.brave.isBrave(),
    },
  };
}
